module.exports = __webpack_public_path__ + "img/user.ba974220.png";